import axios from "axios";
import Store from "@/store";

const API_BASE = "https://places.googleapis.com/v1";
const API_KEY = process.env.VUE_APP_GOOGLE_API_KEY;

export const GooglePlacesDataService = {
  getBaseHeaders() {
    return {
      "Content-Type": "application/json",
      "X-Goog-Api-Key": API_KEY
    };
  },

  getLanguageCode() {
    return Store.getters.gLanguage
      ? Store.getters.gLanguage.toLowerCase()
      : "de";
  },

  async autocomplete(input, options = {}) {
    if (!input || !options.fieldMask) return null;

    try {
      const response = await axios.post(
        `${API_BASE}/places:autocomplete`,
        {
          input,
          languageCode: this.getLanguageCode(),
          ...(options.params || {})
        },
        {
          headers: {
            ...this.getBaseHeaders(),
            "X-Goog-FieldMask": options.fieldMask
          }
        }
      );

      return response.data;
    } catch {
      return null;
    }
  },

  async getPlaceDetails(placeId, options = {}) {
    if (!placeId || !options.fieldMask) return null;

    try {
      const response = await axios.get(
        `${API_BASE}/places/${placeId}`,
        {
          params: {
            languageCode: this.getLanguageCode(),
            ...(options.query || {})
          },
          headers: {
            ...this.getBaseHeaders(),
            "X-Goog-FieldMask": options.fieldMask
          }
        }
      );

      return response.data;
    } catch {
      return null;
    }
  }
};

export default GooglePlacesDataService;
